<template>
	<div>
		<Header />
		<div class="con-900 box-white calc category_section mt-60px mb-60px">
			<div class="padding_section">
				<h2 class="fs-title text-center">Tájékoztató</h2>
				<div class="fs-desc text-justify">
					A
					<b>Minősített Fogyasztóbarát Otthonbiztosítás</b>
					termékek csak
					<b>magánszemélyek</b>
					részére elérhetők.
				</div>
				<div class="fs-desc mt-20px mb-20px italic">
					Magánszemélyként kérjük, nyomja meg a Tovább gombot, amennyiben nem magánszemélyként kíván
					biztosítást kötni, kérjük, válassza Cégként szeretnék biztosítást kötni nyomógombot.
				</div>
			</div>
			<div class="d-flex flex-column justify-center items-center">
				<button class="btn btn-blue" @click="handleStart">Tovább</button>
				<router-link :to="{ name: 'company-form' }" class="mb-18px">
					Cégként szeretnék biztosítást kötni
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import Header from '@/components/Header.vue';
import { mapGetters, mapMutations } from 'vuex';
import CampaignHelper from "@/helpers/campaignHelper";

export default {
	mounted() {
        if (CampaignHelper.isItHomeInsuranceCampaign()) {
            this.setCurrentStep(2);
            this.$router.push({ name: 'property-details' });
        }
		else if (this.getSteps[this.getCurrentStep] !== this.$route.name) {
			this.$router.push({ name: this.getSteps[this.getCurrentStep] });
		}
	},
	components: {
		Header,
	},
	computed: {
		...mapGetters(['getCurrentStep', 'getSteps', 'getCategory']),
	},
	methods: {
		...mapMutations(['setCurrentStep']),
		handleStart() {
			this.setCurrentStep(2);
			this.$router.push({ name: 'property-details' });
		},
	},
};
</script>

<style lang="scss" scoped>
.italic {
	font-style: italic;
}
</style>
